import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@alefeducation/ui-elements-library-core';
import AssignmentContext from '../common/AssignmentContext/AssignmentContext';

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  align-self: flex-end;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  width: fit-content;
`;

export const ControlButtons = ({
  isSubmissionInProgress,
  isReturnButtonEnabled,
  onSave,
  isSaveButtonEnabled,
  onReturn,
  onCancel,
}) => {
  const { t } = useTranslation();
  const {
    assignmentData: { assignmentType },
  } = useContext(AssignmentContext);
  const assignmentTypeForPendo = assignmentType
    .split('_')
    .join('-')
    .toLowerCase();
  return (
    <ButtonContainer>
      <Button
        data-testid="cancelButton"
        variant={'ghost'}
        disabled={isSubmissionInProgress}
        onClick={onCancel}
        size={'lg'}
        className={`data-analytics-${assignmentTypeForPendo}-student-submission-page-cancel`}
      >
        {t('Cancel')}
      </Button>
      <ButtonGroup>
        <Button
          data-testid="saveButton"
          variant={'secondary'}
          size="lg"
          disabled={!isSaveButtonEnabled || isSubmissionInProgress}
          onClick={onSave}
          className={`data-analytics-${assignmentTypeForPendo}-student-submission-page-save`}
        >
          {t('Save')}
        </Button>
        <Button
          data-testid="returnButton"
          disabled={!isReturnButtonEnabled || isSubmissionInProgress}
          onClick={onReturn}
          variant={'primary'}
          size="lg"
          className={`data-analytics-${assignmentTypeForPendo}-student-submission-page-return-assignment`}
        >
          {t('Return')}
        </Button>
      </ButtonGroup>
    </ButtonContainer>
  );
};

ControlButtons.propTypes = {
  isSubmissionInProgress: PropTypes.bool.isRequired,
  isReturnButtonEnabled: PropTypes.bool.isRequired,
  isSaveButtonEnabled: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onReturn: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
